export class Unidade {
    idUnidade = '';
    nomeUnidade = '';
    idUf = '';
    tipologia = '';
    uf = {
        idUf: '',
        siglaUf: '',
        descricao: ''
    };

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/unidade.ts